import { EnterpriseCenterMenuEnum } from "@/apis/model/EnterpriseCenterMenuEnum";
import { UserCenterMenuEnum } from "@/apis/model/UserCenterMenuEnum";
import { UrlHelperExtensions } from "@/url_helpers";

export function urlForCenterMenu(
  menu: EnterpriseCenterMenuEnum | UserCenterMenuEnum,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  query?: { [k: string]: any },
): string {
  const ec = menu as EnterpriseCenterMenuEnum;
  if (EnterpriseCenterMenuEnum[ec]) {
    return UrlHelperExtensions.$EnterpriseCenterMenuUrl(ec, query);
  } else {
    const uc = menu as UserCenterMenuEnum;
    return UrlHelperExtensions.$UserCenterMenuUrl(uc, query);
  }
}
